export default {
  affiliate: {
    // Main navigation
    title: 'सहयोगी',
    cantFindQuestion: 'प्रश्न नहीं मिल रहा?',
    onlineService: 'ऑनलाइन सेवा',
    dashboard: 'डैशबोर्ड',
    myRewards: 'मेरे पुरस्कार',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'निमंत्रण पुरस्कार',
    rules: 'नियम',

    // Team Info
    teamData: 'टीम डेटा',
    details: 'विवरण',
    totalValidFriends: 'कुल वैध मित्र:',
    todayTotalWager: 'आज की कुल बाजी:',
    rewards: 'पुरस्कार',

    // Commission rates
    inviteFriendsCommissionUpTo: 'मित्रों को आमंत्रित करने पर कमीशन तक',
    expandTeamBonus: 'टीम विस्तार बोनस',
    maxLevelCommission: 'अधिकतम स्तर कमीशन',
    inviteFriendsCommission: 'मित्रों को आमंत्रित करने पर कमीशन',
    maxPerformanceCommission: 'अधिकतम प्रदर्शन कमीशन',
    unlimitedAgent: 'असीमित एजेंट',
    unlimitedCommission: 'असीमित कमीशन',
    commissionRate: 'कमीशन दर',

    // Team Invite Friends
    inviteFriendsToEarn: 'कमाने के लिए मित्रों को आमंत्रित करें',
    link: 'लिंक',
    code: 'कोड',
    inviteFriends: 'मित्रों को आमंत्रित करें',
    share: 'साझा करें',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'दावा करें',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'आज प्राप्त',
    
    liveRewards: 'Live Rewards',
    sendTotalCommission: 'कुल कमीशन भेजें',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'आज आमंत्रित मित्र',
    todayDepositFriends: 'आज जमा करने वाले मित्र',
    depositFriends: 'जमा करने वाले मित्र',
    validFriends: 'वैध मित्र',

    // Dialogs
    shareInvitationLink: 'अपना निमंत्रण लिंक साझा करें ताकि वे पंजीकरण कर सकें।',
    shareInvitationCode: 'अपना निमंत्रण कोड साझा करें ताकि वे पंजीकरण के दौरान दर्ज कर सकें।',
    shareQRCode: 'अपना QR कोड साझा करें ताकि वे स्कैन करके पंजीकरण कर सकें।',

    // Share Dialog
    shareTitle: 'साझा करें',
    player: 'खिलाड़ी',
    saveImage: 'छवि सहेजें',
    saveImageSuccess: "छवि सहेजी गई",
    saveImageFailed: "सहेजना विफल, कृपया पुनः प्रयास करें",
    copy: 'कॉपी करें',
    copied: 'कॉपी किया गया!',

    // Received/Withdraw
    received: 'प्राप्त',
    withdraw: 'निकालें',
    history: 'इतिहास',
    referralRewards: 'रेफरल पुरस्कार',
    commission: 'कमीशन',
    depositRebate: 'जमा छूट',
    levelUpRewards: 'लेवल अप पुरस्कार',
    loading: 'लोड हो रहा है...',
    noMoreRecords: 'कोई और रिकॉर्ड नहीं',
    loadMore: 'और लोड करें',
    pending: 'लंबित',
    paid: 'भुगतान किया गया',
    rejected: 'अस्वीकृत',
    unknown: 'अज्ञात',
    upgradeReward: 'लेवल अप पुरस्कार',
    cancelled: 'रद्द किया गया',
    receiving: 'प्राप्त हो रहा है',
    failed: 'विफल',
    expired: 'समाप्त',

    // History Dialog
    pickDate: 'एक तारीख चुनें',
    select: 'चुनें',
    chooseBonus: 'बोनस चुनें',
    all: 'सभी',

    // Invitation Rewards Page
    yourFriendGet: 'आपका मित्र प्राप्त करता है',
    dailyInvitations: 'दैनिक निमंत्रण',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'सहयोगी पुरस्कार कैसे अर्जित करें?',
    shareToFriends: 'मित्रों के साथ साझा करें',
    getUpTo: 'तक प्राप्त करें',
    noticeEnsureCorrect: 'सूचना: सुनिश्चित करें कि निमंत्रण लिंक, QR कोड, या कोड सही है।',

    // Rules - Commission Work
    howCommissionWork: 'कमीशन कैसे काम करता है?',
    agentRatingDescription: 'एजेंट रेटिंग विवरण',
    you: 'आप',
    commissionDescription: 'अपने मित्र B, C, D और आगे के जमा और दांव से कमीशन कमाएं। कमीशन दरों के लिए दाईं ओर का चार्ट देखें।',
    claimConditions: 'दावा शर्तें',
    teamLevel: 'टीम स्तर',
    earnUpTo: "Earn up to",
    expandYourTeam: "अपनी टीम बढ़ाएं",
    earnAnExtra: "अतिरिक्त कमाएं",
    upgradeAgentLevel: "अपना एजेंट स्तर बढ़ाएं",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'कुल आकार',
    teamWager: 'टीम बाजी',
    rebateRewardVary: 'छूट पुरस्कार और टॉप अप पुरस्कार उस दिन आपके टीम स्तर के आधार पर भिन्न होते हैं।',
    teamSizeDescription: 'टीम का आकार: वर्तमान में आपके पास मान्य उपयोगकर्ताओं की संख्या।',
    teamBettingDescription: 'टीम सट्टेबाजी: आपके अधीनस्थों द्वारा एक दिन में लगाई गई कुल सट्टों की संख्या।',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'टीम कमीशन',
    teamCommissionSubTitle: 'अपने नेटवर्क की हर जमा और\nहर दांव से कमाएं।',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'मित्रों को आमंत्रित करें, और दोनों को पुरस्कार मिलेंगे',
    inviteRegisterReceive: 'सफलतापूर्वक मित्रों को पंजीकरण के लिए आमंत्रित करें और प्राप्त करें',
    friendDepositWagerUnlock: 'जब आपका मित्र 10.00 USDT जमा करता है और 50.00 USDT की शर्त लगाता है, तो आप 3.00 USDT का पुरस्कार अनलॉक करते हैं, और आपके मित्र को 2.00 USDT मिलता है।',
    inviteFriendToGet: 'प्राप्त करने के लिए एक मित्र को आमंत्रित करें',
    inviteFriendsEarnRewards: 'मित्रों को आमंत्रित करें और पुरस्कार अर्जित करें',
    shareReferralLink: 'अपने मित्रों के साथ अपना रेफरल लिंक, कोड या QR कोड साझा करें',
    friendsSignUpDeposit: 'मित्र साइन अप करें और जमा करें',
    inviteFriendsRegisterDeposit: 'मित्रों को AFUN पर पंजीकरण करने और पहली जमा करने के लिए आमंत्रित करें।',
    earnBigRewards: 'जब मित्र दांव लगाएं, जमा करें और VIP तक पहुंचें तो पुरस्कार और कमीशन कमाएं।',
    howMakeFriendsSubordinates: 'मित्रों को अपने अधीनस्थ कैसे बनाएं:',
    howMakeFriendsValidUsers: 'अपने मित्रों को मान्य उपयोगकर्ता कैसे बनाएं:',
    successfullyInviteFriends: 'सफलतापूर्वक मित्रों को साइन अप करने के लिए आमंत्रित करें।',
    cumulativeDepositsReach: 'उनकी संचयी जमा राशि 10.00 USDT तक पहुंच जाती है।',
    cumulativeValidBetsReach: 'उनकी संचयी मान्य दांव 50.00 USDT तक पहुंच जाती है।',
    thenBecomeValidUsers: 'फिर, वे मान्य उपयोगकर्ता बन जाएंगे।',
    depositFriendsDescription: 'जब आपके अधीनस्थ मित्र सफलतापूर्वक पैसे जमा करते हैं, तो वे जमा करने वाले मित्र बन जाएंगे।',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'हाल में आमंत्रित मित्र',
    recentDepositFriends: 'हाल में जमा करने वाले मित्र',
    today: 'आज',
    yesterday: 'कल',
    thisMonth: 'इस महीने',
    friendsData: 'मित्रों का डेटा',
    joinDate: 'शामिल होने की तारीख',
    search: 'खोजें',
    level: 'स्तर',
    tier: 'स्तर',
    affiliateTreasureBox: 'सहयोगी खजाना बॉक्स',
    referralRewardsDesc: 'जब आप मित्रों को पंजीकरण के लिए आमंत्रित करते हैं, तो आप और आपके मित्र दोनों को उदार बोनस मिलेंगे।',
    commissionDesc: 'आप और आपकी टीम मिलकर अपने लक्ष्यों को प्राप्त करते हैं और उदार कमीशन अर्जित करते हैं।',
    affiliateTreasureBoxDesc: 'माइलस्टोन बोनस पाने के लिए मित्रों को आमंत्रित करें',
  }
};
